"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DEFAULT_PREVIEW_SIZE", {
  enumerable: true,
  get: function get() {
    return _index.DEFAULT_PREVIEW_SIZE;
  }
});
Object.defineProperty(exports, "MAX_PREVIEW_SIZE", {
  enumerable: true,
  get: function get() {
    return _index.MAX_PREVIEW_SIZE;
  }
});
Object.defineProperty(exports, "UPLOADCARE_CDN_URL", {
  enumerable: true,
  get: function get() {
    return _constants.UPLOADCARE_CDN_URL;
  }
});
Object.defineProperty(exports, "UPLOADCARE_FILE_DATA_KEY", {
  enumerable: true,
  get: function get() {
    return _constants.UPLOADCARE_FILE_DATA_KEY;
  }
});
Object.defineProperty(exports, "UPLOADCARE_IMAGE_SIZE_LIMIT", {
  enumerable: true,
  get: function get() {
    return _constants.UPLOADCARE_IMAGE_SIZE_LIMIT;
  }
});
Object.defineProperty(exports, "UploadcareFile", {
  enumerable: true,
  get: function get() {
    return _index.UploadcareFile;
  }
});
Object.defineProperty(exports, "UploadcareGifVideo", {
  enumerable: true,
  get: function get() {
    return _index.UploadcareGifVideo;
  }
});
Object.defineProperty(exports, "UploadcareImage", {
  enumerable: true,
  get: function get() {
    return _index.UploadcareImage;
  }
});
Object.defineProperty(exports, "awaitUploads", {
  enumerable: true,
  get: function get() {
    return _index.awaitUploads;
  }
});
Object.defineProperty(exports, "isUploadcareImageSizeValid", {
  enumerable: true,
  get: function get() {
    return _index.isUploadcareImageSizeValid;
  }
});
Object.defineProperty(exports, "isUploadedFile", {
  enumerable: true,
  get: function get() {
    return _uploads.isUploadedFile;
  }
});
Object.defineProperty(exports, "isUploadedImage", {
  enumerable: true,
  get: function get() {
    return _uploads.isUploadedImage;
  }
});
Object.defineProperty(exports, "toProgressPromise", {
  enumerable: true,
  get: function get() {
    return _index.toProgressPromise;
  }
});
var _uploads = require("@prezly/uploads");
var _constants = require("./constants.cjs");
var _index = require("./lib/index.cjs");